import { render, staticRenderFns } from "./TrademarkSearchDatabaseList.vue?vue&type=template&id=4ef1a402&"
import script from "./TrademarkSearchDatabaseList.vue?vue&type=script&lang=js&"
export * from "./TrademarkSearchDatabaseList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkSearchDatabaseList.vue?vue&type=style&index=0&id=4ef1a402&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports